import React from "react";
import styled from "styled-components";

const MainContent = () => (
  <PrimaryContent>
    <AboutSection id="about">
      <h1>Tautas Roks</h1>
      <p>
        An energetic folk rock band based in Northamptonshire and Essex. Started
        in 2005, Tautas Roks are an energetic band who are making waves on the
        Ceilidh scene, merging classic English folk tunes with a mixture of
        genres to give a lively, full sound that makes an impact on even the
        biggest venue. They are perfect for your Festival, Wedding or any other
        event you have on.
      </p>
      <p>
        The line-up has changed over the years, although the core of the band
        has remained the same, consisting of Kris Fisher (melodeons), Andy Care
        (guitars) and Mo Fisher (bass). We often go out as a trio, pulling in a
        drummer when the organiser requests a more rockier sound.
      </p>
      <p>
        Past performances include Rudolstadt Festival (Germany), Towersey Folk
        Festival, Sidmouth Folk Week, Broadstairs Folk Week, Warwick Folk
        Festival, Raunds Music Festival and The Music Barn, to name but a few.
      </p>
    </AboutSection>
    <GigsSection id="gigs">
      <h2>Gig Calendar</h2>
      <div className="gig-box">
        <div className="date-box">
          <h3>31</h3>
          <h4>January</h4>
        </div>
        <div className="gig-info-box">
          <h4>Moulton Morris Mens Extravaganza</h4>
          <p>19:00</p>
          <p>Moulton, Northants</p>
        </div>
      </div>
      <div className="gig-box">
        <div className="date-box">
          <h3>17</h3>
          <h4>May</h4>
        </div>
        <div className="gig-info-box">
          <h4>Moulton Village Festival Ceilidh</h4>
          <p>19:00</p>
          <p>Moulton, Northants</p>
        </div>
      </div>
      <div className="gig-box">
        <div className="date-box">
          <h3>14</h3>
          <h4>August</h4>
        </div>
        <div className="gig-info-box">
          <h4>Broadstairs Folk Week</h4>
          <p>19:00</p>
          <p>Broadstairs, Kent</p>
        </div>
      </div>
      <div className="gig-box">
        <div className="date-box">
          <h3>26</h3>
          <h4>September</h4>
        </div>
        <div className="gig-info-box">
          <h4>Saxbys Cider Barn Dance</h4>
          <p>19:00</p>
          <p>Farndish, Wellingborough, Northants</p>
        </div>
      </div>
    </GigsSection>
  </PrimaryContent>
);

const PrimaryContent = styled.div`
  float: left;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 32px;

  @media (min-width: 768px) {
    flex-direction: row;
    padding: 32px 64px;
  }
`;

const AboutSection = styled.section`
  width: 100%;

  @media (min-width: 768px) {
    width: 48%;
  }
`;

const GigsSection = styled.section`
  width: 100%;

  .gig-box {
    display: flex;
    flex-direction: row;
    background: rgba(255, 255, 255, 0.8);
    color: black;
    padding: 16px;
    border-bottom: 1px solid black;
  }

  .gig-box h3,
  h4 {
    margin-bottom: 0 !important;
    font-size: 1.25rem !important;
  }

  .date-box {
    border-right: 1px solid black;
    padding-right: 8px;
    width: 80px;
  }

  .gig-info-box {
    margin-left: 8px;
    text-align: left;
  }

  .gig-info-box p,
  h4 {
    margin-bottom: 0 !important;
  }

  @media (min-width: 768px) {
    width: 48%;

    #gigsContainer {
      width: 500px;
    }

    .gig-box h3 {
      font-size: 2rem !important;
    }

    .gig-box h4 {
      font-size: 1.5rem !important;
    }

    .date-box {
      width: 100px;
    }
  }
`;

export default MainContent;
